import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import GeneralSectionComponent from "../generalSectionComponent";
import SearchBlockRHF from "../../../../components/GeneralComponents/searchBlockRHF/SearchBlockRHF";
import CountriesModal from "./countriesModal/countriesModal";

import { COUNTRIES_COLUMNS } from "../../../../components/GeneralComponents/SearchTable/TablesColumns";

import { options } from "../../../../components/GeneralComponents/searchBlockRHF/optionsSearchBlockRHF";

import {
  getCountriesBySearchParams,
  getCountry,
} from "../../../../redux/directoryMaintenance/countriesReducer/actionsCountries";
import { RESET_COUNTRY, SET_SEARCH_PARAMS_COUNTRIES } from "../../../../redux/types";

import styles from "./countries.module.css";

export default function Countries() {
  const dispatch = useDispatch();
  const [innerOptions, setInnerOptions] = useState({});
  const [searchParams, setSearchParams] = useState({
    countryFullname: "",
    countryName: "",
  });

  const countriesReducer = useSelector((state) => state.countriesReducer);

  const handleChange = async (e) => {
    if (e.target) {
      setSearchParams({
        ...searchParams,
        [e.target.dataset.id]: e.target.value,
      });
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    dispatch({
      type: SET_SEARCH_PARAMS_COUNTRIES,
      data: searchParams,
    });
    dispatch(getCountriesBySearchParams(searchParams));
  };

  const handleClear = () => {
    dispatch({
      type: SET_SEARCH_PARAMS_COUNTRIES,
      data: { countryFullname: "", countryName: "" },
    });
    dispatch({
      type: RESET_COUNTRY,
    });
    dispatch(
      getCountriesBySearchParams({
        countryFullname: "",
        countryName: "",
      }),
    );
    setSearchParams({
      countryFullname: "",
      countryName: "",
    });
  };

  useEffect(() => {
    if (!Object.values(innerOptions).length) setInnerOptions({ ...options.inputsCountries });
    dispatch(getCountriesBySearchParams(searchParams));
  }, []);

  return (
    <>
      {Object.values(innerOptions).length && (
        <div className={styles["content-container"]}>
          <SearchBlockRHF
            options={options.inputsCountries}
            handleChange={handleChange}
            handleSearch={handleSearch}
            handleClear={handleClear}
            searchParams={searchParams}
            externalStyles={styles}
          />
          <GeneralSectionComponent
            title={
              countriesReducer.countries.length > 0
                ? `Результаты поиска: ${countriesReducer.countries.length}`
                : ""
            }
            dataFromStateSelector={(state) => state.countriesReducer.countries}
            getAction={getCountry}
            headerColumns={COUNTRIES_COLUMNS}
            ModalComponent={CountriesModal}
          />
        </div>
      )}
    </>
  );
}
